import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-9 d-flex align-items-center" }
const _hoisted_2 = { class: "col-3" }
const _hoisted_3 = { class: "row mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_three_dot_menu = _resolveComponent("three-dot-menu")!
  const _component_empty_asset = _resolveComponent("empty-asset")!
  const _component_add_asset = _resolveComponent("add-asset")!
  const _component_sub_section = _resolveComponent("sub-section")!
  const _component_other_income_editor = _resolveComponent("other-income-editor")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_sub_section, {
      title: "Any other income",
      helpTitle: "Any other income",
      helpText: _ctx.HelpText.otherIncome()
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOtherIncome, (otherIncome) => {
          return (_openBlock(), _createElementBlock("div", {
            key: otherIncome.id,
            class: "row mb-2"
          }, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(otherIncome.description), 1),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_three_dot_menu, {
                id: otherIncome.id,
                permissions: _ctx.getPermissionSet(otherIncome.editMode, true, true, true),
                "aria-purpose": otherIncome.name,
                onViewClicked: _ctx.onView,
                onEditClicked: _ctx.onEdit,
                onDeleteClicked: _ctx.onDelete
              }, null, 8, ["id", "permissions", "aria-purpose", "onViewClicked", "onEditClicked", "onDeleteClicked"])
            ])
          ]))
        }), 128)),
        _withDirectives(_createElementVNode("div", null, [
          _createVNode(_component_empty_asset, { name: "other income" })
        ], 512), [
          [_vShow, !_ctx.hasOtherIncome]
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_add_asset, {
            name: "income",
            longName: "any other income",
            onAddClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAdd())),
            ref: "addAssetComponent"
          }, null, 512)
        ])
      ]),
      _: 1
    }, 8, ["helpText"]),
    _createVNode(_component_modal, {
      title: _ctx.modalTitle,
      ref: "assetModal",
      idKey: "otherIncome",
      "close-button-aria-label": "Close other income popup editor",
      returnFocusTo: _ctx.addAssetButton
    }, {
      default: _withCtx(() => [
        _createVNode(_component_other_income_editor, {
          ref: "assetEditor",
          onEditFinished: _ctx.onEditFinished
        }, null, 8, ["onEditFinished"])
      ]),
      _: 1
    }, 8, ["title", "returnFocusTo"])
  ], 64))
}